<div class="flex flex-col plans gap-3">
  <div *ngIf="isAnnualSubscription$ | async" id="annual-cta">
    <sbnb-page-level-cta [cta]="annualCta"></sbnb-page-level-cta>
  </div>

  <!-- Plans loaded successfully -->
  <div *ngIf="plans$ | async as plans" class="plan-grid">
    <sbnb-plan-card
      [disabled]="(cannotSwitchPlans$ | async) === true && !plan.current_plan"
      [disabedTooltip]="
        (cannotSwitchPlans$ | async) === true && !plan.current_plan ? 'Contact sales to review your options.' : null
      "
      class="flex"
      *ngFor="let plan of plans"
      [plan]="plan"
      [subscription]="subscription$ | async"
      (selectPlan)="onSelectPlan($event)"></sbnb-plan-card>
  </div>
  <!-- Plans failed to load - happens regularly for suspected scam accounts that have not been granted a subscription yet -->
  <sbnb-alert-card *ngIf="plansError$ | async" context="warning" class="flex-col gap-3">
    <h3>There was a problem loading Hospitable's plans.</h3>
    <div>Please contact support.</div>
  </sbnb-alert-card>
  <div class="flex justify-end w-full"><sbnb-compare-features-link></sbnb-compare-features-link></div>
</div>
<sbnb-loading-spinner *ngIf="plansLoading$ | async" minHeight="200px"></sbnb-loading-spinner>
